import { CATALOG_BASE_URL } from '../constants';
import { downloadBlob, postForFile } from './batch3Api';
import { postJson } from './files';

export { downloadBlob };

export type EvalFormat = 'format1' | 'format2';

export interface TrainingEvalSummary {
  summary: {
    trainee_rows: number;
    excluded_pages: number;
    missing_pages: number;
    bills_scored: number;
    total_marks: number;
    maximum_marks: number;
    percentage: number;
  } | null;
  log: string;
}

export function evaluateTraining(format: EvalFormat, trainee: File, answer: File) {
  const form = new FormData();
  form.append('trainee_file', trainee);
  form.append('answer_file', answer);
  form.append('options', JSON.stringify({ format }));
  return postForFile<TrainingEvalSummary>(
    '/training-evaluation/evaluate',
    form,
    format === 'format1' ? 'Trainee_Assessment_Result.xlsx' : 'Format2_Assessment_Evaluation.xlsx',
    'Evaluation failed'
  );
}

export interface TrainerScoringSheet {
  sheet: string;
  questions: number;
  correct: number;
  wrong: number;
  unanswered: number;
  manual: number;
  marks_allotted: number;
  marks_obtained: number;
  percentage: number;
}

export interface TrainerScoringSummary {
  sheets: TrainerScoringSheet[];
  total_marks: number;
  maximum_marks: number;
  percentage: number;
  manual_review_rows: number;
  notes: string[];
}

export interface TrainerPrepareSummary {
  sheets: { sheet: string; questions: number }[];
  total_questions: number;
  notes: string[];
}

export interface PreparedFile {
  filename: string;
  blob: Blob;
}

export interface PreparedScoreFiles {
  trainer: PreparedFile;
  trainee: PreparedFile;
  summary: TrainerPrepareSummary;
}

const XLSX_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

function toBlob(base64: string): Blob {
  const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
  return new Blob([bytes], { type: XLSX_TYPE });
}

export async function prepareScoreFiles(template: File): Promise<PreparedScoreFiles> {
  const form = new FormData();
  form.append('template_file', template);
  const data = await postJson<{
    summary: TrainerPrepareSummary;
    files: Record<'trainer' | 'trainee', { filename: string; content_base64: string }>;
  }>('/trainer-scoring/prepare', form, 'Could not prepare the files');
  return {
    summary: data.summary,
    trainer: { filename: data.files.trainer.filename, blob: toBlob(data.files.trainer.content_base64) },
    trainee: { filename: data.files.trainee.filename, blob: toBlob(data.files.trainee.content_base64) },
  };
}

export const trainerTemplateUrl = `${CATALOG_BASE_URL}/trainer-scoring/template`;

export function scoreTrainee(trainer: File, trainee: File) {
  const form = new FormData();
  form.append('trainer_file', trainer);
  form.append('trainee_file', trainee);
  return postForFile<TrainerScoringSummary>('/trainer-scoring/score', form, 'Scored score sheet.xlsx', 'Scoring failed');
}
